import moment from 'moment'

// Whether an activity has ended, for the Tulevat / Menneet split of the activity lists.
//
// Activity times are 'YYYY-MM-DDTHH:mm' stored as UTC *wall clock*: 18:00 in the venue is
// saved as 18:00Z. "Now" must be read the same way - the browser's own clock components as
// UTC - or an activity stays under Tulevat for the venue's UTC offset (2-3 h in Finland)
// after it has ended.
//
// Activities created before the form rework (b8478f8, 2026-08-26) can carry a bare time as
// `end` ('13:00', the old form default saved untouched), and one even as `start`. Such an
// end is taken on the start's day, rolled to the next day when not after the start, as
// ActivityTimeRange does. An activity with no dated start or end cannot be placed in time
// and is treated as ended, so it no longer heads the Tulevat list.

const FORMAT = 'YYYY-MM-DDTHH:mm'
const DATED = /^\d{4}-\d\d-\d\dT\d\d:\d\d/
const TIME_ONLY = /^\d\d:\d\d$/

export const wallClockNow = (date = new Date()) =>
  moment.utc([date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()])

// The activity's end as a UTC wall-clock moment, or null when it has no date at all.
export const activityEndMoment = (activity) => {
  const start = activity && typeof activity.start === 'string' && DATED.test(activity.start) ? moment.utc(activity.start, FORMAT) : null
  const end = activity ? activity.end : null
  if (typeof end === 'string' && DATED.test(end)) return moment.utc(end, FORMAT)
  if (!start) return null
  if (typeof end === 'string' && TIME_ONLY.test(end)) {
    const sameDay = moment.utc(start.format('YYYY-MM-DD') + 'T' + end, FORMAT)
    return sameDay.isAfter(start) ? sameDay : sameDay.add(1, 'day')
  }
  return start
}

export const isActivityPast = (activity, now = wallClockNow()) => {
  const end = activityEndMoment(activity)
  return !end || end.isSameOrBefore(now)
}
